import {Component, OnDestroy, OnInit} from '@angular/core';
import {SubscriptionService} from "../service/subscription.service";
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../models/language";
import {LANG} from "../constants/local-storage.contant";
import {CookieUtils} from "../utils/cookie.utils";
import {AccountType} from "../enums/account-type";
import {SubscriptionType} from "../enums/subscription-type";
import {SubscriptionResponse} from "../interface/subscriptionResponse";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {
  ConfirmCardRemovingDialogComponent
} from "./confirm-card-removing-dialog/confirm-card-removing-dialog.component";
import {MySubscriptionsFactory} from "./my-subscriptions-factory.service";
import {FormControl} from "@angular/forms";
import {InitPaymentRequest} from "../models/payment/initPaymentRequest";
import {InitPaymentResponse} from "../models/payment/initPaymentResponse";
import {PaymentBackUrlParamsHandlerService} from "../subscription-payment/payment-back-url-params-handler.service";
import {BehaviorSubject, Observable, Subscription} from "rxjs";
import {SubscriptionPlanInfoModel} from "../models/subscriptionPlanInfo.model";
import {SubscriptionPlanInfoResponse} from "../interface/subscriptionPlanInfoResponse";
import {SubscriptionPlanInfoService} from "../service/subscription-plan-info.service";
import {ToggleElModel} from "../layouts/toggle/toggle-el.model";
import {MoveOrRemoveDialogComponent} from "../subscription-plan/move-or-remove-dialog/move-or-remove-dialog.component";
import {DeleteProfileCardComponent} from "../profile-card/delete-profile-card/delete-profile-card.component";
import {CANCEL_YOUR_PLAN_DESCRIPTION, CANCEL_YOUR_PLAN_TITLE} from "../constants/deleteProfileCards.constant";
import {ViewStateService} from "../service/view-state.service";
import {UserCardService} from "../service/user-card.service";
import {UserService} from "../service/user.service";
import {SharedService} from "../service/shered.service";
import {UserCardResponse} from "../interface/userCardResponse";
import {UserResponse} from "../interface/userResponse";
import {DOLLAR_TO_DRAM_CURRENCY} from "../constants/currency.constant";
import {SharedConstants} from "../utilityClass/sharedConstants";
import {CreditCardService} from "../service/credit-card.service";
import {CreditCardResponse} from "../models/creditCardResponse";
import {SnackBarUtil} from "../qr-copy-message/snack-bar-util.service";
import {MockupDataModel} from "../qr-copy-message/mockup-data.model";
import {AMERIA_FORM, PAYMENT_ID_NAME} from "../constants/payment.constant";
import {SubscriptionBuyingService} from "../service/subscription-buying.service";
import {saveAs} from "file-saver";
import {PDF_NAME} from "../constants/pdf.constant";
import {BankPaymentRecordsService} from "../service/bank-payment-records.service";
import {BankPaymentRecordModel} from "../models/bankPaymentRecordModel";
import {ActivatedRoute} from "@angular/router";
import {SaveChangesComponent} from "../profile-card/save-changes-popup/save-changes.component";
import { Router } from '@angular/router';
import {CREDIT_CARD_CONFLICT_DIALOG} from "../constants/matDialogConstants";
import {LanguageService} from "../service/language.service";
import {TranslationService} from "../service/translation.service";

@Component({
  selector: 'app-my-subscriptions',
  templateUrl: './my-subscriptions.component.html',
  styleUrls: [
    './my-subscriptions.component.scss',
    '../header/header.component.scss',
    '../subscription-payment/subscription-payment.component.scss',
    '../subscription-plan/subscription-plan-card/subscription-plan-card.component.scss',
    '../shared/scss/userCardCommon.scss',
    '../create-card/create-card.component.scss',
  ]
})
export class MySubscriptionsComponent implements OnInit, OnDestroy {

  protected isMyPlanActive: boolean = true;
  protected isIndividualActive: boolean = true;
  protected isIndividuals: boolean = true;
  protected isYearly: boolean = false;
  protected isShowAllSubscriptions: boolean = false

  protected activeSubscriptionPlan!: SubscriptionResponse;
  protected activeAdditionalSubscriptionPlan!: SubscriptionResponse;
  protected activeIndividualSubscriptionPlan!: SubscriptionResponse;
  protected activeTeamSubscriptionPlan!: SubscriptionResponse;

  protected currentLang: string = '';
  private languageSubscription?: Subscription;
  private myPlanActiveSubscription?: Subscription;
  private allSubscriptionActiveSubscription?: Subscription;
  private isPlanSwitching: boolean = false;
  private subscriptions: Subscription[] = [];

  protected subscriptionIndividualsPlanInfoModel: SubscriptionPlanInfoModel[] = [];
  protected individualsSubscriptionPlans: SubscriptionPlanInfoResponse[] = [];
  protected subscriptionTeamsPlanInfoModel: SubscriptionPlanInfoModel[] = [];
  protected teamsSubscriptionPlans: SubscriptionPlanInfoResponse[] = [];
  protected inactiveSubscriptionPlanIds: Set<number> = new Set();
  protected additionalCards: UserCardResponse[] = [];
  protected currentUser!: UserResponse
  protected invoiceHistory: Array<BankPaymentRecordModel> = [];

  protected readonly Language = Language;
  protected readonly AccountType = AccountType;
  protected readonly SubscriptionType = SubscriptionType;
  protected readonly Number = Number;
  protected readonly ToggleElModel = ToggleElModel;
  protected readonly FREE: string = 'subscription_plan_content.free';

  private isDialogOpened = false;

  dialogRef: MatDialogRef<DeleteProfileCardComponent> | undefined;
  moveRemoveDialogRef: MatDialogRef<MoveOrRemoveDialogComponent> | undefined;
  currentLang$: Observable<string> = this.languageService.currentLanguage$;
  protected creditCards: Array<CreditCardResponse> = [];
  protected readonly HISTORY_INITIAL_VISIBLE_COUNT = 5;
  protected readonly HISTORY_VISIBLE_STEP = 5;
  protected individualVisibleHistoryCount: number = this.HISTORY_INITIAL_VISIBLE_COUNT;
  protected teamVisibleHistoryCount: number = this.HISTORY_INITIAL_VISIBLE_COUNT;

  protected additionalCardBuyingStates = {
    default: true,
    cardQty: false,
    addCard: false,
    addAdditional: false,
  };

  protected cardQty: FormControl<string | null> = new FormControl<string>('');
  protected readonly DEFAULT_ADDITIONAL_CARDS_NUMBER_LENGTH = 2;
  protected readonly UNLIM_ADDITIONAL_CARDS_NUMBER_LENGTH = 6;

  public static isAdditionalCardsBought: BehaviorSubject<SubscriptionResponse | null> = new BehaviorSubject<SubscriptionResponse | null>(null);

  constructor(
    private translate: TranslateService,
    private subscriptionService: SubscriptionService,
    private subscriptionBuyingService: SubscriptionBuyingService,
    private dialog: MatDialog,
    private paymentBackUrlParamsHandler: PaymentBackUrlParamsHandlerService,
    private subscriptionPlanDataService: SubscriptionPlanInfoService,
    private viewStateService: ViewStateService,
    private userCardService: UserCardService,
    private userService: UserService,
    private sharedService: SharedService,
    private creditCardService: CreditCardService,
    private snackBarUtil: SnackBarUtil,
    private bankPaymentRecordsService: BankPaymentRecordsService,
    private route: ActivatedRoute,
    private router: Router,
    private languageService: LanguageService,
    private translationService: TranslationService
  ) {

    this.subscriptions.push(
    this.myPlanActiveSubscription = MySubscriptionsFactory.isMyPlanActive.subscribe({
      next: (isMyPlanActive: boolean) => {
        if (this.isMyPlanActive !== isMyPlanActive) {
          this.isMyPlanActive = isMyPlanActive;
        }
      }
    })
    );
    this.subscriptions.push(
    this.allSubscriptionActiveSubscription = MySubscriptionsFactory.isAllSubscriptionActive.subscribe({
      next: (isAllSubscriptionActive: boolean) => {
        this.isShowAllSubscriptions = isAllSubscriptionActive;
      }
    })
    )

    this.isMyPlanActive = MySubscriptionsFactory.isMyPlanActive.value;
    this.isShowAllSubscriptions = MySubscriptionsFactory.isAllSubscriptionActive.value;

    this.paymentBackUrlParamsHandler.handleQueryParams();
    MySubscriptionsComponent.isAdditionalCardsBought.subscribe({
      next: (value) => {
        if (value) {
          this.activeAdditionalSubscriptionPlan = value;
          this.isMyPlanActive = true;
          this.isIndividualActive = false;
          this.setAdditionalCardBuyingStates('addCard');
          this.setActiveSubscriptionTeam();
        }
      }
    });
    this.loadAllUserCards();
  }

  isSubscriptionPlanDisabledByMissingPayment(planId: number): boolean {
    return this.inactiveSubscriptionPlanIds.has(planId);
  }

  getActiveSubscriptionPlanId(name: 'team' | 'individual') {
    if (name === 'team') {
      const activeId = this.activeTeamSubscriptionPlan?.subscriptionInfoResponse?.id;
      return activeId ? Number(activeId) : 0;
    } else {
      const activeId = this.activeIndividualSubscriptionPlan?.subscriptionInfoResponse?.id;
      return activeId ? Number(activeId) : 0;
    }
  }

  ngOnInit() {
    this.currentLang = this.languageService.getLanguageFromStorage();

    this.subscriptions.push(
      this.languageService.currentLanguage$.subscribe((lang: string) => {
        if (this.currentLang !== lang) {
          this.currentLang = lang;
          if (!this.isPlanSwitching) {
            setTimeout(() => {
              this.loadIndividualSubscription();
              this.loadTeamSubscriptions();
              this.loadAllSubscriptionPlans();
              this.getSubscriptionHistory(this.isIndividualActive);
            }, 0);
          }
        }
      })
    );

    this.loadIndividualSubscription();
    this.loadTeamSubscriptions();
    this.loadAllSubscriptionPlans();
    this.handleSubscriptionStateFromCreatingCard();
    this.handleSubscriptionStateFromTeam();
    this.subscribeToCancelSubscriptionState();
    this.getAdditionalCards();
    this.getSubscriptionHistory(this.isIndividualActive);
    this.subscriptions.push(
    this.sharedService.aClickedEvent.subscribe({
      next: () => {
        this.loadTeamSubscriptions();
      }
    })
    );
    this.handleAddNewCardProcess();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.isDialogOpened = false;
    this.viewStateService.setIsCancelSubscription(false);
  }

  get activeSubscriptionTitle() {
    const title: string | null | undefined = this.activeTeamSubscriptionPlan.subscriptionInfoResponse.title;
    return title ? this.translateSubscriptionTitle(title) : '';
  }

  getTranslatedSubscriptionTitle(subscriptionType: SubscriptionType): string {
    if (!subscriptionType) {
      return '';
    }
    const translationKey = `subscription_plans.${subscriptionType.toLowerCase()}`;
    return this.translate.instant(translationKey);
  }

  translateSubscriptionTitle(subscriptionType: string): Observable<string> {
    const titleMap: Record<string, string> = {
      Starter: 'subscription_plans.starter',
      Standard: 'subscription_plans.standard',
      Premium: 'subscription_plans.premium',
      Basic: 'subscription_plans.basic',
      Professional: 'subscription_plans.professional',
      Unlim: 'subscription_plans.unlim',
      Free: 'subscription_plans.free',
    };

    return this.translationService.get(titleMap[subscriptionType] ?? subscriptionType);
  }

  get activeSubscriptionAdditionalCardsCount() {
    const extraCardLimit: number | null | undefined = this.activeTeamSubscriptionPlan.subscriptionInfoResponse.extraCardLimit;
    return extraCardLimit ? extraCardLimit : 'unlim';
  }

  get isActivatedPromoCode() {
    return typeof this.activeSubscriptionPlan.discountedAmount == 'number';
  }

  get getDiscountedPrice() {
    if (typeof this.activeSubscriptionPlan.discountedAmount == 'number') {
      return this.roundPrice(this.activeSubscriptionPlan.discountedAmount);
    }
    return 0;
  }

  private loadIndividualSubscription(): void {
    this.subscriptionService.getActiveIndividualSubscription().subscribe({
      next: (activeIndividualSubscriptionPlan) => {
        this.activeIndividualSubscriptionPlan = activeIndividualSubscriptionPlan;
        if (!activeIndividualSubscriptionPlan.isActive) {
          this.inactiveSubscriptionPlanIds.add(Number(activeIndividualSubscriptionPlan.subscriptionInfoResponse.id));
        }
        if (this.isIndividualActive){
          this.setActiveSubscriptionIndividual();
        }
      }
    });
  }

  private loadTeamSubscriptions(): void {
    this.subscriptionService.getActiveTeamSubscriptions().subscribe({
      next: (activeTeamSubscriptionPlans) => {
        activeTeamSubscriptionPlans.forEach(plan => {
          if (!plan.isActive) {
            this.inactiveSubscriptionPlanIds.add(Number(plan.subscriptionInfoResponse.id));
          }
        });
        this.setTeamSubscriptionPlans(activeTeamSubscriptionPlans);
        if (!this.isIndividualActive){
          this.setActiveSubscriptionTeam();
        }
      }
    });
  }

  private setTeamSubscriptionPlans(plans: SubscriptionResponse[]): void {
    let main: SubscriptionResponse | undefined;
    let additional: SubscriptionResponse | undefined;
    plans.forEach(p => {
      if (!p.subscriptionInfoResponse?.isAdditional && !main) {
        main = p;
      }
      else if (p.subscriptionInfoResponse?.isAdditional && !additional) {
        additional = p;
      }
    });
    if (main) {
      this.activeTeamSubscriptionPlan = main;
    }
    if (additional) {
      this.activeAdditionalSubscriptionPlan = additional;
      this.setAdditionalCardBuyingStates('addCard');
    } else {
      this.setAdditionalCardBuyingStates('default');
    }
  }

  private loadAllSubscriptionPlans(): void {
    this.subscriptionPlanDataService.findAll().subscribe({
      next: (subscriptionPlans) => {
        this.initializeSubscriptionPlans(subscriptionPlans);
      }
    });
  }

  private subscribeToCancelSubscriptionState(): void {
    const cancelSubscriptionSub = this.viewStateService.isCancelSubscription$.subscribe({
      next: (isCancelSubscription) => {
        if (isCancelSubscription && !this.isDialogOpened) {
          this.openCancelSubscriptionModal();
          this.isDialogOpened = true;
        }
      }
    });
    this.subscriptions.push(cancelSubscriptionSub);
  }

  initializeSubscriptionPlans(subscriptionPlans: SubscriptionPlanInfoResponse[]): void {
    this.individualsSubscriptionPlans = this.findByAccountType(subscriptionPlans, AccountType.INDIVIDUAL);
    this.teamsSubscriptionPlans = this.findByAccountType(subscriptionPlans, AccountType.TEAM);
    this.updateSubscriptionModels();
  }

  get selectedCard() {
    return this.creditCards.find((someCard) => someCard.isActive);
  }

  get additionalCardsLength() {
    const isSubscriptionTypeUnlim: boolean = this.activeTeamSubscriptionPlan.subscriptionInfoResponse.subscriptionType == SubscriptionType.UNLIM;
    if (isSubscriptionTypeUnlim) {
      return this.UNLIM_ADDITIONAL_CARDS_NUMBER_LENGTH;
    }
    return this.DEFAULT_ADDITIONAL_CARDS_NUMBER_LENGTH;
  }

  get addAdditionalCardsErrorMessage() {
    const newExtraCardLimit = this.activeAdditionalSubscriptionPlan.subscriptionInfoResponse.extraCardLimit;
    const mainExtraCardLimit = this.activeSubscriptionPlan.subscriptionInfoResponse.extraCardLimit;
    return this.translate.instant('cards_limit_warning', {
      newExtraCardLimit,
      mainExtraCardLimit
    });
  }

  get purchaseAdditionalCardsErrorMessage() {
    const extraCardLimit = this.activeSubscriptionPlan.subscriptionInfoResponse.extraCardLimit;
    return `Your subscription allows a maximum of ${extraCardLimit} cards`;
  }

  openMoveOrRemoveDialog(): void {
    if (this.additionalCards.length) {
      this.moveRemoveDialogRef = this.dialog.open(MoveOrRemoveDialogComponent, {
        width: "50%",
        height: "60%",
        data: {
          additionalCards: this.additionalCards,
          activeTeamSubscriptionPlan: this.activeTeamSubscriptionPlan,
          currentUser: this.currentUser
        }
      });
    }
    if (this.moveRemoveDialogRef) {
      const sub = this.moveRemoveDialogRef.afterClosed().subscribe(result => {
        this.getAdditionalCards();
      });
      this.subscriptions.push(sub);
    }
  }

  getAdditionalCards() {
  const sub =  this.userService.currentUser.subscribe(response => {
      this.currentUser = response
      this.userCardService.findAllAdditionalCardsByUser(response.id).subscribe(additionalCards => {
        this.additionalCards = additionalCards
      })
    })
    this.subscriptions.push(sub);
  }

  download(subscriptionId: bigint) {
    this.subscriptionService.download(subscriptionId).subscribe({
      next: (blob: Blob) => {
        saveAs(blob, PDF_NAME);
      }
    })
  }

  protected setAdditionalCardBuyingStates(name: 'default' | 'cardQty' | 'addCard' | 'addAdditional') {
    this.additionalCardBuyingStates.default = name == "default";
    this.additionalCardBuyingStates.cardQty = name == "cardQty";
    this.additionalCardBuyingStates.addCard = name == "addCard";
    this.additionalCardBuyingStates.addAdditional = name == "addAdditional";
  }

  protected selectCreditCard(card: CreditCardResponse) {
    if (this.selectedCard && this.selectedCard.id == card.id) return;
    this.creditCardService.updateActivity(card.id, true).subscribe({
      next: () => {
        this.creditCards.forEach(creditCard => {
          creditCard.isActive = false;
        });
        card.isActive = true;
      },
      error: () => {
        this.showSnackbar(MockupDataModel.error("Error updating credit card."), SnackBarUtil.CLASSES.error);
      }
    });
  }

  protected openConfirmRemovingDialog(card: CreditCardResponse) {
    this.dialog.open(ConfirmCardRemovingDialogComponent).afterClosed().subscribe({
      next: (res) => {
        if (typeof res == 'boolean' && res) {
          this.creditCardService.deleteById(card.id).subscribe({
            next: () => {
              this.creditCards = this.creditCards.filter(creditCard => creditCard !== card);
            },
            error: () => {
              this.showSnackbar(MockupDataModel.error("Error deleting credit card."), SnackBarUtil.CLASSES.error);
            }
          })
        }
      }
    });
  }

  protected togglePlan(value: boolean) {
    if (this.isMyPlanActive === value) {
      return;
    }

    this.isPlanSwitching = true;
    this.toggleIndividual(true);
    this.isMyPlanActive = value;
    MySubscriptionsFactory.isMyPlanActive.next(value);
    this.isShowAllSubscriptions = !value;

    setTimeout(() => {
      this.isPlanSwitching = false;
    }, 100);
  }

  toggleTerm(isYearly: boolean): void {
    this.isYearly = isYearly;
    this.updateSubscriptionModels();
  }

  isSubscriptionCanceledInfoActive() {
    return !!this.activeSubscriptionPlan &&
      this.isMyPlanActive &&
      !this.isShowAllSubscriptions &&
      !this.activeSubscriptionPlan.isActive &&
      !this.activeSubscriptionPlan.isStarter;
  }

  protected toggleIndividual(value: boolean) {
    this.isIndividuals = value
    this.isIndividualActive = value;
    this.getSubscriptionHistory(value)
    value ? this.setActiveSubscriptionIndividual() : this.setActiveSubscriptionTeam();
  }

  private setActiveSubscriptionIndividual() {
    this.activeSubscriptionPlan = this.activeIndividualSubscriptionPlan;
  }

  private setActiveSubscriptionTeam() {
    this.activeSubscriptionPlan = this.activeTeamSubscriptionPlan;
  }

  protected calculateTotalPrice() {
    const count = this.cardQty.getRawValue() ? this.cardQty.getRawValue() : 0;
    return this.activeSubscriptionPlan.subscriptionInfoResponse.nextCardPrice * Number(count);
  }

  protected calculateAddAdditionalTotalPrice() {
    const oldCardsCount = this.activeAdditionalSubscriptionPlan.subscriptionInfoResponse.cardCount;
    const newCardsCount = Number(this.cardQty.getRawValue());
    const totalCardsCount = newCardsCount + oldCardsCount;
    const nextCardPrice = this.activeSubscriptionPlan.subscriptionInfoResponse.nextCardPrice;
    return nextCardPrice * Number(totalCardsCount);
  }

  protected isCardQtyInvalid() {
    const rawValue: string | null = this.cardQty.getRawValue();
    const isSubscriptionTypeUnlim: boolean = this.activeTeamSubscriptionPlan.subscriptionInfoResponse.subscriptionType == SubscriptionType.UNLIM;
    if (rawValue && rawValue.length > 0 && !isSubscriptionTypeUnlim) {
      const numberRawValue = Number(rawValue);
      const extraCardLimit = this.activeSubscriptionPlan.subscriptionInfoResponse.extraCardLimit;
      return numberRawValue > extraCardLimit;
    }
    return false;
  }

  protected isAddAdditionalCardQtyInvalid() {
    const rawValue: string | null = this.cardQty.getRawValue();
    const isSubscriptionTypeUnlim: boolean = this.activeTeamSubscriptionPlan.subscriptionInfoResponse.subscriptionType == SubscriptionType.UNLIM;
    if ((rawValue && rawValue.length > 0) && !isSubscriptionTypeUnlim) {
      const numberRawValue = Number(rawValue);
      const extraCardLimit = this.activeAdditionalSubscriptionPlan.subscriptionInfoResponse.extraCardLimit;
      return numberRawValue > extraCardLimit;
    }
    return false;
  }

  protected buyAdditionalCards() {
    const additionalCardsCount = this.cardQty.getRawValue();
    if (!additionalCardsCount) return;

    let isMonthly = !this.activeSubscriptionPlan.isYearly;
    const opaque: string = JSON.stringify({
      additionalCardsCount: additionalCardsCount,
      isMonthly: isMonthly,
      isPayment: true,
      currentUserId: this.currentUser.id
    });
    const actualAmount = this.calculateTotalPrice();
    const request: InitPaymentRequest = InitPaymentRequest.initForAdditionalCardsBuying("Purchase Additional Subscription", actualAmount, opaque, isMonthly);
    this.subscriptionBuyingService.init(request).subscribe({
      next: (paymentResponse: InitPaymentResponse) => {
        window.location.href = AMERIA_FORM.replace(PAYMENT_ID_NAME, paymentResponse.PaymentID);
      }
    });
  }

  protected addAdditionalCards() {
    const additionalCardsCount = this.cardQty.getRawValue();
    if (!additionalCardsCount) return;

    let isMonthly = !this.activeSubscriptionPlan.isYearly;
    const opaque: string = JSON.stringify({
      additionalCardsCount: additionalCardsCount,
      isMonthly: isMonthly,
      isAddAdditional: true,
      currentUserId: this.currentUser.id
    });
    const actualAmount = this.calculateTotalPrice();
    const request: InitPaymentRequest = InitPaymentRequest.initForAdditionalCardsBuying("Add Additional Subscription", actualAmount, opaque, isMonthly);
    this.subscriptionBuyingService.init(request).subscribe({
      next: (paymentResponse: InitPaymentResponse) => {
        window.location.href = AMERIA_FORM.replace(PAYMENT_ID_NAME, paymentResponse.PaymentID);
      }
    });
  }

  protected getAdditionalCardsAndSubscriptionPrice() {
    const subscriptionPlanPrice = this.activeSubscriptionPlan.subscriptionInfoResponse.price;

    const additionalCardPrice = this.activeSubscriptionPlan.subscriptionInfoResponse.nextCardPrice;
    const additionalCardsCount = this.activeAdditionalSubscriptionPlan.subscriptionInfoResponse.cardCount;
    const additionalCardsTotalPrice = additionalCardPrice * additionalCardsCount;

    return additionalCardsTotalPrice + subscriptionPlanPrice;
  }

  protected getAdditionalCardsPrice() {
    const additionalCardPrice = this.activeSubscriptionPlan.subscriptionInfoResponse.nextCardPrice;
    const additionalCardsCount = this.activeAdditionalSubscriptionPlan.subscriptionInfoResponse.cardCount;
    return additionalCardPrice * additionalCardsCount;
  }

  protected cancelSubscription() {
    this.openCancelSubscriptionModal();
  }

  protected isShowCancelButton() {
    if (!this.activeSubscriptionPlan) {
      this.viewStateService.setIsActiveCancelSubscription(false);
      return false;
    }

    const showButton = !this.activeSubscriptionPlan.isStarter &&
      this.activeSubscriptionPlan.isActive &&
      this.isMyPlanActive;

    this.viewStateService.setIsActiveCancelSubscription(showButton);
    return showButton;
  }

  protected roundPrice(price: number): number {
    return Math.round(price * 10) / 10;
  }

  protected pairCreditCard() {
    const description = "Adding new credit card";
    const initPaymentRequest = InitPaymentRequest.initForCreditCardParing(description, 1)
    this.creditCardService.addNewCreditCard(initPaymentRequest).subscribe({
      next: (paymentResponse: InitPaymentResponse) => {
        window.location.href = AMERIA_FORM.replace(PAYMENT_ID_NAME, paymentResponse.PaymentID);
      }
    })
  }

  protected handleAddNewCardProcess() {
    this.subscriptions.push(
    this.route.queryParams.subscribe(params => {
      const isCardAddedSuccess = params['isCardAddedSuccess'];
      const isCreditCardConflict = params['isCreditCardConflict'];
      const holderId = params['holderId'];

      if (isCardAddedSuccess === 'true' || isCardAddedSuccess === true) {
        this.showSnackbar(MockupDataModel.success("Card added successfully."), SnackBarUtil.CLASSES.success);
        this.clearQueryParams();
      } else if (isCardAddedSuccess === 'false' || isCardAddedSuccess === false) {
        this.showSnackbar(MockupDataModel.error("Something went wrong. Please try again later."), SnackBarUtil.CLASSES.error);
        this.clearQueryParams();
      } else if ((isCreditCardConflict === 'true' || isCreditCardConflict === true) && holderId) {
        this.handleCardConflict(holderId);
        this.clearQueryParams();
      }
    })
  )
  }

  private handleCardConflict(cardHolderId: string) {
    this.dialog.open(SaveChangesComponent, {
      data: {
        title: CREDIT_CARD_CONFLICT_DIALOG.title,
        description: CREDIT_CARD_CONFLICT_DIALOG.description,
        confirmButtonText: CREDIT_CARD_CONFLICT_DIALOG.confirmButtonText,
        cancelButtonText: CREDIT_CARD_CONFLICT_DIALOG.cancelButtonText
      }
    }).afterClosed().subscribe((confirmed: boolean) => {
      confirmed ? this.showSnackbar(MockupDataModel.success(this.translate.instant('dialogs.credit_card_conflict.success_message')), SnackBarUtil.CLASSES.success) : this.handleDuplicateCreditCardDeletion(cardHolderId);
    });
  }

  private handleDuplicateCreditCardDeletion(cardHolderId: string) {
    this.creditCardService.deleteByCardHolderId(cardHolderId).subscribe({
      next: () => {
        this.creditCards = this.creditCards.filter(card => card.cardHolderId !== cardHolderId);
        const hasActiveCard = this.creditCards.some(card => card.isActive);
        const firstCard = this.creditCards[0];
        if (!hasActiveCard && firstCard) {
          this.selectCreditCard(firstCard);
        }
      }, error: () => {
        this.showSnackbar(MockupDataModel.error("Error deleting credit card."), SnackBarUtil.CLASSES.error);
      }
    })
  }

  private clearQueryParams() {
    this.router.navigate([], {
      queryParams: {},
      replaceUrl: true
    });
  }

  private findByAccountType(subscriptionPlans: SubscriptionPlanInfoResponse[], accountType: AccountType): SubscriptionPlanInfoResponse[] {
    return subscriptionPlans.filter(plan => {
      return plan.parent.accountType === accountType;
    });
  }

  private updateSubscriptionModels(): void {
    this.subscriptionIndividualsPlanInfoModel = this.individualsSubscriptionPlans.map(subscriptionPlan => new SubscriptionPlanInfoModel(
      subscriptionPlan,
      this.isIndividuals,
      this.isFirstPlan(subscriptionPlan.subscriptionType),
      this.isSecondPlan(subscriptionPlan.subscriptionType),
      this.isYearly
    ));
    this.subscriptionTeamsPlanInfoModel = this.teamsSubscriptionPlans.map(subscriptionPlan => new SubscriptionPlanInfoModel(
      subscriptionPlan,
      this.isIndividuals,
      this.isFirstPlan(subscriptionPlan.subscriptionType),
      this.isSecondPlan(subscriptionPlan.subscriptionType),
      this.isYearly
    ));
  }

  private openCancelSubscriptionModal(): void {
    if (!this.isDialogOpened) {
      this.dialogRef = this.dialog.open(DeleteProfileCardComponent, {
        data: {
          deleteTitle: CANCEL_YOUR_PLAN_TITLE,
          deleteDescription: CANCEL_YOUR_PLAN_DESCRIPTION,
          isSubscriptionPlanCancelPage: true
        }
      });
      this.dialogRef.afterClosed().subscribe((result) => {
        this.isDialogOpened = false;
        this.viewStateService.setIsCancelSubscription(false);
        if (result) {
          this.subscriptionService.cancelSubscription(this.activeSubscriptionPlan.id).subscribe(() => {
            this.activeSubscriptionPlan.isActive = false;
          });
        }
      });
    }
  }

  private handleSubscriptionStateFromTeam(): void {
    this.togglePlan(!history.state.isShowAllSubscriptions);
    this.toggleIndividual(history.state.isIndividualActive ?? true)
  }

  private handleSubscriptionStateFromCreatingCard(): void {
    this.isShowAllSubscriptions = history.state.isShowAllSubscriptions ?? false;
    this.togglePlan(!this.isShowAllSubscriptions);
  }

  private isFirstPlan(subscriptionType: SubscriptionType): boolean {
    return subscriptionType === SubscriptionType.STARTER || subscriptionType === SubscriptionType.BASIC;
  }

  private isSecondPlan(subscriptionType: SubscriptionType): boolean {
    return subscriptionType === SubscriptionType.STANDARD || subscriptionType === SubscriptionType.PROFESSIONAL;
  }

  private loadAllUserCards() {
    this.creditCardService.getAll().subscribe({
      next: (creditCards: Array<CreditCardResponse>) => {
        this.creditCards = creditCards.sort((a, b) => {
          if (a.isActive) return -1;
          if (b.isActive) return 1;
          return 0;
        });
        if (this.creditCards.length === 1 && !this.creditCards[0].isActive) {
          this.selectCreditCard(this.creditCards[0]);
        }
      }
    });
  }

  private showSnackbar(data: MockupDataModel, panelClassNames: string[]): void {
    this.snackBarUtil.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: panelClassNames,
      data: data
    });
  }

  protected readonly DOLLAR_TO_DRAM_CURRENCY = DOLLAR_TO_DRAM_CURRENCY;
  protected readonly SharedConstants = SharedConstants;

  get visibleInvoiceHistory(): Array<BankPaymentRecordModel> {
    return this.invoiceHistory.slice(0, this.currentVisibleHistoryCount);
  }

  get canShowViewMoreHistory(): boolean {
    return this.invoiceHistory.length > this.currentVisibleHistoryCount;
  }

  get canShowViewLessHistory(): boolean {
    return this.invoiceHistory.length > this.HISTORY_INITIAL_VISIBLE_COUNT &&
      this.currentVisibleHistoryCount > this.HISTORY_INITIAL_VISIBLE_COUNT;
  }

  protected viewMoreHistory(): void {
    if (this.isIndividualActive) {
      this.individualVisibleHistoryCount += this.HISTORY_VISIBLE_STEP;
      return;
    }
    this.teamVisibleHistoryCount += this.HISTORY_VISIBLE_STEP;
  }

  protected viewLessHistory(): void {
    if (this.isIndividualActive) {
      this.individualVisibleHistoryCount = this.HISTORY_INITIAL_VISIBLE_COUNT;
      return;
    }
    this.teamVisibleHistoryCount = this.HISTORY_INITIAL_VISIBLE_COUNT;
  }

  private get currentVisibleHistoryCount(): number {
    return this.isIndividualActive ? this.individualVisibleHistoryCount : this.teamVisibleHistoryCount;
  }

  private getSubscriptionHistory(isIndividualActive: boolean) {
    this.bankPaymentRecordsService.getAll(isIndividualActive).subscribe(invoiceHistory => {
      this.invoiceHistory = invoiceHistory
    })
  }
}
